// theme.js
export const theme = {
  primaryDark: '#0D0C1D',
  primaryLight: '#fffdef',
  primaryHover: '#343078',
  mobile: '576px',
};
